import { render, staticRenderFns } from "./ProDetail.vue?vue&type=template&id=be7addc8&scoped=true"
import script from "./ProDetail.vue?vue&type=script&lang=js"
export * from "./ProDetail.vue?vue&type=script&lang=js"
import style0 from "./ProDetail.vue?vue&type=style&index=0&id=be7addc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7addc8",
  null
  
)

export default component.exports